import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { submitRating } from '../services/ratingService';
import './RatingForm.css';

function RatingForm() {
  const { isAuthenticated, getToken } = useAuth();
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Si l'utilisateur n'est pas connecté, afficher un message
  if (!isAuthenticated) {
    return (
      <div className="rating-form-container">
        <div className="rating-form">
          <h1>Notez l'application</h1>
          <p className="auth-required-message">
            Vous devez être connecté pour noter l'application.
          </p>
        </div>
      </div>
    );
  }

  const handleStarClick = (value) => {
    setRating(value);
    setError(null);
  };

  const handleStarHover = (value) => {
    setHoveredRating(value);
  };

  const handleStarLeave = () => {
    setHoveredRating(0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    // Validation
    if (rating === 0) {
      setError('Veuillez sélectionner une note (1 à 5 étoiles)');
      return;
    }

    setLoading(true);

    try {
      const token = getToken();
      await submitRating(rating, comment, token);
      setSuccess(true);
      setRating(0);
      setComment('');
      setHoveredRating(0);
      
      // Masquer le message de succès après 5 secondes
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch (err) {
      setError(err.error || err.message || 'Une erreur est survenue lors de l\'envoi de votre avis');
    } finally {
      setLoading(false);
    }
  };

  const renderStars = () => {
    const stars = [];
    const displayRating = hoveredRating || rating;

    for (let i = 1; i <= 5; i++) {
      stars.push(
        <button
          key={i}
          type="button"
          className={`star-button ${i <= displayRating ? 'active' : ''}`}
          onClick={() => handleStarClick(i)}
          onMouseEnter={() => handleStarHover(i)}
          onMouseLeave={handleStarLeave}
          aria-label={`${i} étoile${i > 1 ? 's' : ''}`}
        >
          <span className="star-icon">★</span>
        </button>
      );
    }
    return stars;
  };

  return (
    <div className="rating-form-container">
      <div className="rating-form">
        <h1>Notez l'application</h1>

        <form onSubmit={handleSubmit} className="rating-form-content">
          {/* Section Note */}
          <div className="rating-section">
            <p className="rating-prompt">Dites-nous ce que vous pensez de l'application</p>
            <div className="stars-container">
              {renderStars()}
            </div>
            {rating > 0 && (
              <p className="rating-selected">
                Vous avez sélectionné {rating} étoile{rating > 1 ? 's' : ''}
              </p>
            )}
          </div>

          {/* Section Commentaire */}
          <div className="comment-section">
            <p className="comment-prompt">Nous sommes ouverts à vos suggestions</p>
            <div className="form-group">
              <textarea
                id="comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Partagez vos suggestions, commentaires ou retours d'expérience..."
                rows={6}
                maxLength={2000}
                className="comment-textarea"
              />
              <span className="char-count">{comment.length} / 2000 caractères</span>
            </div>
          </div>

          {/* Messages d'erreur et de succès */}
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          {success && (
            <div className="success-message">
              ✓ Votre avis a été enregistré avec succès. Merci pour votre retour !
            </div>
          )}

          {/* Bouton de soumission */}
          <button
            type="submit"
            className="submit-rating-button"
            disabled={loading || rating === 0}
          >
            {loading ? 'Envoi en cours...' : 'Envoyer mon avis'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RatingForm;
